/**
 * HTMLエレメントにCSSクラスを追加します
 *
 * @param {Element} el HTMLエレメント
 * @param {String} className 追加するCSSクラス名
 * @return {Element} HTMLエレメント
 */
export function addClass(el, className) {
  const classes = getClasses(el)
  if (!classes.includes(className)) el.className = classes.concat(className).join(' ')
  return el
}

/**
 * HTMLエレメントからCSSクラスを除去します
 *
 * @param {Element} el HTMLエレメント
 * @param {String} className 除去するCSSクラス名
 * @return {Element} HTMLエレメント
 */
export function removeClass(el, className) {
  const classes = getClasses(el)
  if (classes.includes(className)) el.className = classes.filter(v => v !== className).join(' ')
  return el
}

function getClasses({ className }) {
  return className.split(' ').filter(v => v)
}
